var _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUkFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V21H28V-3H-4Z",
    fill: "#2E42A5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_610_8269",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -4,
    y: -3,
    width: 32,
    height: 24
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 -3V21H28V-3H-4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_610_8269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-7.56299 19.2856L-0.521298 22.2637L28.1599 0.238052L31.8743 -4.18743L24.3442 -5.18279L12.6458 4.30869L3.2298 10.7037L-7.56299 19.2856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-6.59912 21.3724L-3.01171 23.1006L30.5403 -4.59835H25.5032L-6.59912 21.3724Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5635 19.2856L24.5218 22.2637L-4.15945 0.238052L-7.87378 -4.18743L-0.343708 -5.18279L11.3547 4.30869L20.7707 10.7037L31.5635 19.2856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3232 20.7835L27.7358 22.5117L13.449 10.6524L9.21329 9.32735L-8.23114 -4.17185H-3.194L14.2406 9.00693L18.8717 10.5958L31.3232 20.7835Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-7-inside-1_610_8269",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7778 5H30.0278V13H15.7778V23H8.22217V13H-5.97217V5H8.22217V-5H15.7778V5Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.7778 5H30.0278V13H15.7778V23H8.22217V13H-5.97217V5H8.22217V-5H15.7778V5Z",
    fill: "#F50100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7778 5H13.7778V7H15.7778V5ZM30.0278 5H32.0278V3H30.0278V5ZM30.0278 13V15H32.0278V13H30.0278ZM15.7778 13V11H13.7778V13H15.7778ZM15.7778 23V25H17.7778V23H15.7778ZM8.22217 23H6.22217V25H8.22217V23ZM8.22217 13H10.2222V11H8.22217V13ZM-5.97217 13H-7.97217V15H-5.97217V13ZM-5.97217 5V3H-7.97217V5H-5.97217ZM8.22217 5V7H10.2222V5H8.22217ZM8.22217 -5V-7H6.22217V-5H8.22217ZM15.7778 -5H17.7778V-7H15.7778V-5ZM15.7778 5V7H30.0278V5V3H15.7778V5ZM30.0278 5H28.0278V13H30.0278H32.0278V5H30.0278ZM30.0278 13V11H15.7778V13V15H30.0278V13ZM15.7778 13H13.7778V23H15.7778H17.7778V13H15.7778ZM15.7778 23V21H8.22217V23V25H15.7778V23ZM8.22217 23H10.2222V13H8.22217H6.22217V23H8.22217ZM8.22217 13V11H-5.97217V13V15H8.22217V13ZM-5.97217 13H-3.97217V5H-5.97217H-7.97217V13H-5.97217ZM-5.97217 5V7H8.22217V5V3H-5.97217V5ZM8.22217 5H10.2222V-5H8.22217H6.22217V5H8.22217ZM8.22217 -5V-3H15.7778V-5V-7H8.22217V-5ZM15.7778 -5H13.7778V5H15.7778H17.7778V-5H15.7778Z",
    fill: "white",
    mask: "url(#path-7-inside-1_610_8269)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUkFlagIcon);
export default __webpack_public_path__ + "static/media/ukFlagIcon.6fecb3d3d8ca55b60b543df6c2df9cc6.svg";
export { ForwardRef as ReactComponent };